import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Safely extract a string from API error detail (handles 422 validation arrays). */
/** YYYY-MM-DD for local calendar, `days` after a base date or today (safe for HTML date inputs). */
export function addDaysIsoLocal(baseOrDays, maybeDays) {
  const hasExplicitBase = maybeDays !== undefined;
  const add = Number(hasExplicitBase ? maybeDays : baseOrDays);
  const safeAdd = Number.isFinite(add) ? add : 0;
  const d = hasExplicitBase ? new Date(baseOrDays) : new Date();
  if (Number.isNaN(d.getTime())) {
    return '';
  }
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + safeAdd);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Only strict YYYY-MM-DD (or ISO datetime prefix) for HTML date inputs; otherwise ''. */
export function sanitizeHtmlDateValue(raw) {
  if (raw == null || raw === '') return '';
  const s = String(raw).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  if (/^\d{4}-\d{2}-\d{2}T/.test(s)) return s.slice(0, 10);
  return '';
}

export function getErrorMessage(detail, fallback = 'An error occurred') {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    const msgs = detail.map(d => {
      const loc = (d.loc || []).filter(Boolean).join(' → ');
      const msg = d.msg || d.message || 'Invalid value';
      return loc ? `${loc}: ${msg}` : msg;
    });
    return msgs.join('; ');
  }
  if (detail && typeof detail === 'object' && detail.msg) return detail.msg;
  return fallback;
}
